module.exports = __webpack_public_path__ + "static/media/599.767 (8).d17c7398.pdf";